import { useMutation } from "react-query";
import { deleteMedication } from "api/customers";
import { useGlobalToast } from "components/GlobalToastProvider";

const useDeleteMedication = (options: Record<string, any> = {}) => {
  const { onSuccess = () => {}, onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading, ...rest } = useMutation(
    (id: number) => deleteMedication(id),
    {
      onSuccess: (response, variables) => {
        showToast({ message: "Medication deleted successfully." });
        onSuccess(response, variables);
      },
      onError: (error: any) => {
        const errorMessage = error?.response?.data?.error || "Failed to delete medication";
        showToast({ message: errorMessage, errorState: true });
        onError(error);
      },
      ...otherOptions,
    }
  );

  return {
    deleteMedicationMutation: mutate,
    isDeleteMedicationLoading: isLoading,
    ...rest,
  };
};

export default useDeleteMedication;
